<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field class="col-12">
          <mat-label>Status</mat-label>
          <mat-hint>Pour valider la requête, il suffit de certifier le bien</mat-hint>
          <mat-select formControlName="status" required placeholder="">
            <mat-option disabled value="OPEN">{{
              certificationHelper.getCertificationsRequestStatusName('OPEN')
            }}</mat-option>
            <mat-option value="IN_PROGRESS">{{
              certificationHelper.getCertificationsRequestStatusName('IN_PROGRESS')
            }}</mat-option>
            <mat-option value="REFUSED">{{
              certificationHelper.getCertificationsRequestStatusName('REFUSED')
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-group row">
        <mat-form-field class="col-12">
          <mat-label>Message</mat-label>
          <textarea matInput placeholder="" type="text" formControlName="message"></textarea>
          <mat-error>
            <span *ngIf="f('message').hasError('maxlength')"
              >Le message ne peut pas dépasser 160 caractères</span
            >
          </mat-error>
        </mat-form-field>
      </div>
      <div class="text-center">
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          appTooltip="Valider"
          type="submit"
          [disabled]="formSubmitting"
        >
          Valider
        </button>
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          mat-dialog-close
          appTooltip="Annuler"
          (click)="onNoClick()"
        >
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
